/**
 * PRV-008: Interface para Solicitud de Edición de Factibilidad Corporativa
 *
 * Permite a los asesores solicitar edición de materiales/equipos en factibilidades
 * aprobadas, requiriendo autorización del supervisor comercial.
 */

import { IFactibilidadCorporativo } from "./factibilidad_corporativo.interface";

/**
 * Respuesta paginada de solicitudes de edición
 */
export interface ISolicitudEdicionFactibilidadResp {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: ISolicitudEdicionFactibilidad[];
}

/**
 * Datos del usuario simplificados
 */
export interface IUserDataSimple {
  username: string;
  first_name: string;
  last_name: string;
}

/**
 * Interface principal de Solicitud de Edición de Factibilidad
 */
export interface ISolicitudEdicionFactibilidad {
  id_solicitud_edicion_factibilidad: string;
  codigo: string;
  numero_referencia: string;

  // Relación con Factibilidad Corporativa
  factibilidad_corporativa: string;
  factibilidad_corporativa_data?: IFactibilidadCorporativo;

  // Estado y gestión de la solicitud
  estado_solicitud: EstadoSolicitudEdicionEnum;
  motivo: string;
  observaciones_gestion?: string;

  // Auditoría de creación
  user_create: string;
  user_create_data?: IUserDataSimple;
  empresa_create: string;
  area_create: string;
  departamento_create: string;
  canal_venta_create: string;

  // Gestión (quien aprueba/rechaza)
  user_gestiona?: string;
  user_gestiona_data?: IUserDataSimple;
  fecha_gestiona?: string;

  // Auditoría base
  estado: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
}

/**
 * Parámetros para filtrar y paginar solicitudes
 */
export interface ISolicitudEdicionFactibilidadParams {
  page?: number;
  page_size?: number;
  estado_solicitud?: string;
  factibilidad_corporativa__codigo?: string;
  canal_venta_create__codigo?: string;
  // Para crear solicitud
  factibilidad_corporativa?: string;
  motivo?: string;
  // Para actualizar solicitud
  observaciones_gestion?: string;
}

/**
 * Estados posibles de la solicitud de edición
 */
export enum EstadoSolicitudEdicionEnum {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
}

/**
 * Tipo para crear una nueva solicitud
 */
export type CreateSolicitudEdicionFactibilidad = Pick<
  ISolicitudEdicionFactibilidad,
  'factibilidad_corporativa' | 'motivo'
>;

/**
 * Tipo para actualizar una solicitud (aprobar/rechazar)
 */
export type UpdateSolicitudEdicionFactibilidad = Pick<
  ISolicitudEdicionFactibilidad,
  'estado_solicitud' | 'observaciones_gestion'
>;
